module.exports = __webpack_public_path__ + "images/emoji/no_good.2ba2453293fc9c6677e5.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/no_good.png
// module id = 5ejR
// module chunks = 14